export enum TransactionActionResultType {
  Success = 1,
  PartialSuccess = 2,
  Failure = 3,
}
